import { Card, Checkbox, CircleIconContainer } from "@letsbit/milkylb";
import React, { useState } from "react";
import { CardItemProps } from "./types";
import { ReactComponent as CardIcon } from "assets/images/cards/card.svg";
import { CARD_TYPE } from "@letsbit/malcolmlb";
import { useIntl } from "react-intl";
import { messages } from "./messages";
import { useGetCards } from "hooks/kaibacorp/useGetCards";

export const CardItem: React.FC<CardItemProps> = ({
  element: card,
  className,
  isSelected,
  onClick,
  dataCypressId,
}) => {
  const { formatMessage } = useIntl();
  const { data: cards } = useGetCards();

  const [isChecked, setIsChecked] = useState(isSelected);

  return cards ? (
    <Card
      className={`shrink-0 ${className}`}
      key={card.id}
      title={
        card.metadata?.name
          ? card.metadata.name
          : card.card_type.type === CARD_TYPE.VIRTUAL
            ? formatMessage(messages.virtualCard)
            : formatMessage(messages.physicalCard)
      }
      subtitle={`· · · ·  ${card.last_four}`}
      icon={<CircleIconContainer icon={CardIcon} />}
      onClick={() => {
        onClick?.(card.id);
        isChecked ? setIsChecked(false) : setIsChecked(true);
      }}
    >
      <Checkbox checked={isChecked} data-cypress-id={dataCypressId} />
    </Card>
  ) : null;
};
